<template>
  <div class="badge">
    <span :class="['method', method]">{{ method }}</span>
    <span class="url">
      <text-highlighter :search-words="[':\\w+']" :text-to-highlight="url" />
    </span>
  </div>
</template>

<script setup lang="ts">
import TextHighlighter from 'vue-highlight-words';

defineProps({
  method: { type: String, required: true },
  url: { type: String, required: true },
});
</script>

<style scoped lang="scss">
.badge {
  font: var(--vvd-typography-base-code);
  word-break: break-all;

  .method {
    text-transform: uppercase;
    padding: 4px 8px 4px 12px;
    border-radius: 15px 0 0 15px;

    &.post {
      color: #183a1e;
      background: #d7f2e8;
    }
    &.get {
      color: #0e306d;
      background: #d6eefc;
    }
    &.put {
      color: #440291;
      background: #f3e7f8;
    }
    &.patch {
      color: #183a1e;
      background: #dbf3f6;
    }
    &.delete {
      color: #6e0000;
      background: #fde8eb;
    }
  }

  .url {
    padding: 4px 12px 4px 8px;
    border-radius: 0 15px 15px 0;

    color: var(--vvd-color-neutral-800);
    background-color: #f2f2f2;
  }
}

mark {
  background-color: inherit;
  color: #33aaee;
}
</style>
